const MOBILEUSERCONFIG = {
  vehicle: false,
  lowerProduct: 'swingbase',
  upperProduct: false,
  accessories: []
};
jQuery(document).ready(function($) {
  $('.mobile-widget-wr.vehicle-level .heading').click(function() {
    $('.mobile-widget-wr.vehicle-level .options').slideToggle();
  });
  $('.mobile-widget-wr.vehicle-level .selected-option:not(.readonly) .close').click(function() {
    MOBILEUSERCONFIG.vehicle = false;
    MOBILEUSERCONFIG.lowerProduct = 'swingbase';
    MOBILEUSERCONFIG.upperProduct = false;
    MOBILEUSERCONFIG.accessories = [];
    $('.mobile-widget-wr .selected-option:not(.readonly)').hide();
    $('.mobile-vehicle-slider .items').slick('unslick');
    $('.mobile-vehicle-slider .items').empty();
    $('.mobile-vehicle-slider').hide();
    $('.mobile-widget-wr.vehicle-level .heading').show();
    $('.mobile-widget-wr.vehicle-level .options').show().slideUp();
    $('.mobile-widget-wr:not(.vehicle-level)').hide();
    $('.mobile-widget-wr.vehicle-level .selected-option.readonly').hide();
    $('#configurator-mobile .save').hide();
  });

  $('.mobile-widget-wr.vehicle-level .options li').click(function() {
    MOBILEUSERCONFIG.vehicle = $(this).data('vehicle');
    $('.mobile-widget-wr.vehicle-level .heading').hide();
    $('.mobile-widget-wr.vehicle-level .options').hide();
    $('.mobile-widget-wr.vehicle-level .selected-option:not(.readonly)').show();
    const vehicleText = $('.mobile-widget-wr .options li[data-vehicle="' + MOBILEUSERCONFIG.vehicle + '"]').text();
    $('.mobile-widget-wr .selected-option:not(.readonly) .text').text(vehicleText);
    $('.mobile-widget-wr .selected-option:not(.readonly)').show();
    
    // Initialize slider
    if(!$('.mobile-vehicle-slider .items').is(':empty')) {
      $('.mobile-vehicle-slider .items').slick('unslick');
      $('.mobile-vehicle-slider .items').empty();
    }
    const vehicle = EXOSETTINGS.vehicles[MOBILEUSERCONFIG.vehicle];
    let vehicle_r = $('<div class="item rear ' + MOBILEUSERCONFIG.vehicle + '"><img class="vehicle" src="' + vehicle.rear.noshadow + '" /></div>');
	let vehicle_c = $('<div class="item corner ' + MOBILEUSERCONFIG.vehicle + '"><img class="vehicle" src="' + vehicle.corner.noshadow + '" /></div>');
    let vehicle_o = $('<div class="item rear open ' + MOBILEUSERCONFIG.vehicle + '"><img class="vehicle" src="' + vehicle.rear.noshadow + '" /></div>');
	$('.mobile-vehicle-slider .items').append(vehicle_c);
    $('.mobile-vehicle-slider .items').append(vehicle_r);
    $('.mobile-vehicle-slider .items').append(vehicle_o);
    $('.mobile-vehicle-slider .items').slick({
      arrows: false,
      dots: true,
      adaptiveHeight: true
    });
    $('.mobile-vehicle-slider .items').slick('slickGoTo', 0);
    $('.mobile-vehicle-slider .items').slick('refresh');
    $('.mobile-vehicle-slider').show();
    $('.mobile-widget-wr:not(.vehicle-level), .mobile-widget-wr:not(.vehicle-level) .heading').show();
    $('.mobile-widget-wr:not(.vehicle-level) .slider').slideUp();
    $('.mobile-widget-wr:not(.vehicle-level) .items').slick('refresh');
    $('#configurator-mobile .save').show();

    $('.mobile-widget-wr.vehicle-level .selected-option.readonly').hide();
    $('.mobile-widget-wr.lower-level .selected-option, .mobile-widget-wr.upper-level .selected-option').hide();
    $('.mobile-widget-wr.accessory-level .selected-option').remove();
    
    // Select Swingbase by default
    $('.mobile-widget-wr.vehicle-level .selected-option.swingbase').show();
    $('.mobile-widget-wr.lower-level .heading').trigger('click');
    mobileAttachProducts();
    // Hide error message in upper level
    $('.mobile-widget-wr.upper-level .error').hide();
  });
  
  // Vehicle Slider
  $('.mobile-widget-wr.vehicle-level .selected-option.upperdeck .close').click(function() {
    $('.mobile-widget-wr.upper-level .selected-option').hide();
    $('.mobile-widget-wr.upper-level .heading').show();
    $('.mobile-widget-wr.upper-level .slider').slideUp();
    MOBILEUSERCONFIG.upperProduct = false;
    $(this).parent().hide();
    mobileAttachProducts();
  });
  
  // Mobile options sliders
  for(var productKey in EXOSETTINGS.products) {
    let product = EXOSETTINGS.products[productKey];
    let sliderItem = $('<div class="item" data-item="' + productKey + '"><h5>' + product.label + '</h5><img src="' + product.photo + '" /><p>' + product.description + '</p></div>');
    if (product.upperLevel) {
      $('.mobile-widget-wr.upper-level .items').append(sliderItem.clone());
    }
    if (product.lowerLevel) {
      $('.mobile-widget-wr.lower-level .items').append(sliderItem.clone());
    }
    if (product.accessoryLevel) {
      $('.mobile-widget-wr.accessory-level .items').append(sliderItem.clone());
    }
    sliderItem.remove();
  }
  
  // Lower Level
  $('.mobile-widget-wr.lower-level .items').slick({
    prevArrow: $('#mobile-lower-level-slider-prev'),
    nextArrow: $('#mobile-lower-level-slider-next'),
    dots: false,
    adaptiveHeight: true
  });
  $('.mobile-widget-wr.lower-level .items .item').click(function() {
    const widget = $(this).parents('.lower-level')[0];
    $('.mobile-widget-wr.vehicle-level .selected-option.swingbase').show();
    MOBILEUSERCONFIG.lowerProduct = $(this).data('item');
    if ($(this).data('item') != 'swingbase') {
      $(widget).find('.heading, .slider').hide();
      $(widget).find('.selected-option .text').text('Lower Level - ' + EXOSETTINGS['products'][MOBILEUSERCONFIG.lowerProduct].label);
      $(widget).find('.selected-option').show();
    }
    
    // In case of Doubleup is selected
    if (MOBILEUSERCONFIG.lowerProduct == 'doubleup') {
      $('.mobile-widget-wr.vehicle-level .selected-option.upperdeck').hide();
      $('.mobile-widget-wr.upper-level .slider').slideUp();
      $('.mobile-widget-wr.upper-level .selected-option').hide();
      MOBILEUSERCONFIG.upperProduct = false;
    }
    mobileAttachProducts();
  });
  $('.mobile-widget-wr.lower-level .selected-option .close').click(function() {
    const widget = $(this).parents('.lower-level')[0];
    $(widget).find('.heading, .slider').show();
    MOBILEUSERCONFIG.lowerProduct = 'swingbase';
//     $('.mobile-widget-wr.vehicle-level .selected-option.swingbase').hide();
    $(widget).find('.selected-option .text').text('');
    $(widget).find('.selected-option').hide();
    $('.mobile-widget-wr.lower-level .slider .items').slick('refresh');
    mobileAttachProducts();
    // Hide error message in upper level
    $('.mobile-widget-wr.upper-level .heading').show();
    $('.mobile-widget-wr.upper-level .error').hide();
  });
  
  // Upper Level
  $('.mobile-widget-wr.upper-level .items').slick({
    prevArrow: $('#mobile-upper-level-slider-prev'),
    nextArrow: $('#mobile-upper-level-slider-next'),
    dots: false,
    adaptiveHeight: true
  });
  $('.mobile-widget-wr.upper-level .items .item').click(function() {
    const widget = $(this).parents('.upper-level')[0];
    $('.mobile-widget-wr.vehicle-level .selected-option.upperdeck').show();
    MOBILEUSERCONFIG.upperProduct = $(this).data('item');
    if ($(this).data('item') != 'upperdeck') {
      $(widget).find('.heading, .slider').hide();
      $(widget).find('.selected-option .text').text('Upper Level - ' + EXOSETTINGS['products'][MOBILEUSERCONFIG.upperProduct].label);
      $(widget).find('.selected-option').show();
    }
    mobileAttachProducts();
  });
  $('.mobile-widget-wr.upper-level .selected-option .close').click(function() {
    const widget = $(this).parents('.upper-level')[0];
    $(widget).find('.heading, .slider').show();
    MOBILEUSERCONFIG.upperProduct = 'upperdeck';
//     $('.mobile-widget-wr.vehicle-level .selected-option.upperdeck').hide();
    $(widget).find('.selected-option .text').text('');
    $(widget).find('.selected-option').hide();
    $('.mobile-widget-wr.upper-level .slider .items').slick('refresh');
    mobileAttachProducts();
  });
  
  // Accessory Level
  $('.mobile-widget-wr.accessory-level .items').slick({
    prevArrow: $('#mobile-accessories-slider-prev'),
    nextArrow: $('#mobile-accessories-slider-next'),
    dots: false,
    adaptiveHeight: true
  });
  $('.mobile-widget-wr.accessory-level .items .item').click(function() {
    const accessory = $(this).data('item');
    if (MOBILEUSERCONFIG.accessories.indexOf(accessory) == -1) {
      MOBILEUSERCONFIG.accessories.push(accessory);
      const optionElem = $('<div class="selected-option" data-item="' + accessory + '"><span class="text">Accessories - ' + EXOSETTINGS['products'][accessory].label + '</span><span class="close">&times;</span></div>');
      optionElem.show();
      $('.mobile-widget-wr.accessory-level').prepend(optionElem);
      $(optionElem).click(function() {
        MOBILEUSERCONFIG.accessories.splice(MOBILEUSERCONFIG.accessories.indexOf(accessory), 1);
        $(this).remove();
        mobileAttachProducts();
      });
      mobileAttachProducts();
    }
  });
  
  // Options headings click event
  $('.mobile-widget-wr:not(.vehicle-level) .heading').click(function() {
    const parent = $(this).parent();
    if (MOBILEUSERCONFIG.lowerProduct == 'doubleup' && $(parent).hasClass('upper-level')) {
      $(parent).find('.selected-option').hide();
      $(parent).find('.slider').hide();
      $(parent).find('.error').show();
    } else {
      $(parent).find('.slider').slideToggle();
      $(parent).find('.items').slick('refresh');
    }
    
    // Auto-select TopShelf when opening Upper Level
    if (MOBILEUSERCONFIG.lowerProduct != 'doubleup' && MOBILEUSERCONFIG.upperProduct == false && $(parent).hasClass('upper-level')) {
      $('.mobile-widget-wr.vehicle-level .selected-option.upperdeck').show();
      MOBILEUSERCONFIG.upperProduct = 'upperdeck';
      mobileAttachProducts();
    }
  });
  
  // Save configuration
  $('#configurator-mobile .save').click(function() {
    $('#configurator-mobile .main').hide();
    const selectionsDiv = $('#configurator-mobile .save-options .userdata .selections');
    selectionsDiv.empty();
	let el = $('<div><label>Vehicle</label><p>' + EXOSETTINGS['vehicles'][MOBILEUSERCONFIG.vehicle].label + '</p></div>');
    selectionsDiv.append(el);
    if (MOBILEUSERCONFIG.lowerProduct) {
      el = $('<div><label>Required Lower Level Base</label><p>EXO SwingBase<span class="price">$569.00</span></p></div>');
      selectionsDiv.append(el);
      if (MOBILEUSERCONFIG.lowerProduct != 'swingbase') {
        el = $('<div><label>Mount 1</label><p>' + EXOSETTINGS['products'][MOBILEUSERCONFIG.lowerProduct].label + '<span class="price">$' + EXOPRICES[MOBILEUSERCONFIG.lowerProduct] + '</span></p></div>');
        selectionsDiv.append(el);
      }
    }
    if (MOBILEUSERCONFIG.upperProduct) {
      el = $('<div><label>Required Upper Level Base</label><p>EXO TopShelf<span class="price">$439.00</span></p></div>');
      selectionsDiv.append(el);
      if (MOBILEUSERCONFIG.upperProduct != 'upperdeck') {
        el = $('<div><label>Mount 2</label><p>' + EXOSETTINGS['products'][MOBILEUSERCONFIG.upperProduct].label + '<span class="price">$' + EXOPRICES[MOBILEUSERCONFIG.upperProduct] + '</span></p></div>');
        selectionsDiv.append(el);
      }
    }
    for (var i = 0; i < MOBILEUSERCONFIG.accessories.length; i++) {
      el = $('<div><label>Accessories</label><p>' + EXOSETTINGS['products'][MOBILEUSERCONFIG.accessories[i]].label + '<span class="price">$' + EXOPRICES[MOBILEUSERCONFIG.accessories[i]] + '</span></p></div>');
      selectionsDiv.append(el);
    }
    $('#configurator-mobile .save-options').show();
  });
  $('#configurator-mobile .cancel-save').click(function() {
    $('#configurator-mobile .main').show();
    $('#configurator-mobile .save-options').hide();
  });
});